import SkipContent from '@ingka/skip-content';
import { translate } from '@repo/phrase';
import { Carousel } from '@repo/ui/carousel';

import { ActiveFilters } from '@/components/filters/active-filters';
import { AllFilters } from '@/components/filters/all-filters';
import { DaysFilterWrapper } from '@/components/filters/days-filter';
import { SearchAsset } from '@/components/filters/search';
import { useSearch } from '@/components/filters/search/search.hooks';
import { TypeFilterWrapper } from '@/components/filters/type-filter';
import { QueryFetchingIndicator } from '@/components/query-fetching-indicator/query-fetching-indicator.component';

import { useResponsive } from '@/hooks/responsive.hooks';
import { getAppConfig } from '@/utils/window.utils';

import styles from './styles.module.scss';

export const FiltersContainer = () => {
    const { isDesktop } = useResponsive();
    const { hasFilter } = useSearch();
    const daysFilterEnabled = getAppConfig().filters.noOfDays.enable;

    return (
        <div className={styles.filters}>
            <SkipContent
                label={translate('skip_content_target_name', { targetName: translate('skip_content_asset_list') })}
                targetId="assets-table-rows"
            />
            <div className={styles.filters_row}>
                <Carousel>
                    <SearchAsset />
                    {daysFilterEnabled && <DaysFilterWrapper />}
                    {isDesktop && <TypeFilterWrapper />}
                    <AllFilters />
                </Carousel>
                <QueryFetchingIndicator source="asset_list" />
            </div>
            {hasFilter && (
                <>
                    <hr className={styles.divider} />
                    <ActiveFilters />
                </>
            )}
        </div>
    );
};
